
import { useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import List from '@mui/joy/List';
import Chip from '@mui/joy/Chip';
import Stack from '@mui/joy/Stack';

import { getIcon } from 'utils/misc';
import { RootStoreContext } from 'stores/root_store';

import CollabInviteAvailableListItem from './CollabInviteAvailableListItem';

const _CollabInviteAvailableList = observer(( { paged, variant="collab" }: { paged: boolean, variant?: string }) => {
    const store = useContext(RootStoreContext).collabInviteStore;
    const invites = store.getInvitesByStatus('available', variant);
    const [page, setPage] = useState(1);
    const DownIcon = getIcon('ArrowDropDown');
    const PAGE_SIZE = 3;
    const showing = paged ? invites.slice(0, page * PAGE_SIZE) : invites;

    return (
		<List
        sx={{
            backgroundColor: "background.surface",
        }}

        >

            { showing.map((invite) =>
                <CollabInviteAvailableListItem
                    key={invite.key}
                    invite={invite} /> ) }

            { paged &&
                <Stack
                    alignItems="center"
                    direction="row"
                    spacing={1}
                    justifyContent="center" sx={{ py: 2 }}>

                    { page > 1 && (
                        <Chip
                            variant="outlined"
                            color="neutral"
                            onClick={() => setPage(page - 1)}
                            endDecorator={<DownIcon sx={{ transform: 'rotate(180deg)' }} />}
                            slotProps={{ root: { component: 'span' } }}
                        >Show Fewer</Chip>
                    ) }

                    { invites.length > page * PAGE_SIZE && (
                        <Chip
                            variant="outlined"
                            color="neutral"
                            onClick={() => setPage(page + 1)}
                            endDecorator={<DownIcon />}
                            slotProps={{ root: { component: 'span' } }}
                        >Show More</Chip>
                    ) }
                </Stack>
            }

        </List>

    );
});

export default _CollabInviteAvailableList;
